import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './CarouselStyles.css';
import axios from 'axios';
import { ApiStorage, ApiUrl } from '../../../services/ApiRest';




export const RestauranteCarousel = () => {
    const scrollRef = useRef(null);
    const [aliados, setaliados] = useState([])

    const scroll = (direction) => {
        const container = scrollRef.current;
        const scrollAmount = container.offsetWidth * 0.1;
        container.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    };

    const loadData = async () => {
        await axios.get(ApiUrl + "partner-list/Restaurantes")
            .then(response => {
                const data = response.data;
                setaliados(data);

                //cargamos los datos nuevos
                const script = document.createElement("script");
                script.src = `/assets/dataTable/dataTable.js`;
                script.async = true;
                document.body.appendChild(script);
            })
            .catch(e => {
                console.log(e)
            })
    }

    useEffect(() => {
        loadData();
        if (aliados.length > 0) {
            scrollRef.current.scrollLeft = 0;

        }
    }, []);

    return (
        <>
            {(aliados.length > 0) ?
                <div>
                    <h3 className='camping-letters text-center'>RESTAURANTES</h3>
                    <div className="carousel-container">
                        <button className="scroll-button left" onClick={() => scroll('left')}>
                            {/* <i className="fa-solid fa-chevron-left"></i> */}
                            <i className="far fa-arrow-alt-circle-left"></i>
                        </button>

                        <div className="carouselTour" ref={scrollRef}>
                            {aliados.map((partner) => (
                                <div className="carousel-card" key={partner.partner_id}>
                                    <Link to={`/partner/${partner.partner_id}`} className="carousel-link">
                                        {/* <img src={partner.img_logo} alt={partner.name} /> */}
                                        <img src={`${ApiStorage + partner.img_logo}`} style={{ width: '100%' }} className="card-img-top" alt="..."></img>

                                        <div className="carousel-info">
                                            <p><i className="fas fa-hotel"></i>{' : ' + partner.partner_name}</p>

                                            <p><i className="fas fa-city"></i>{' : ' + partner.city}</p>
                                            <p><i className="fas fa-mobile-alt"></i> {': ' + partner.phone}</p>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>

                        <button className="scroll-button right" onClick={() => scroll('right')}>
                            <i className="far fa-arrow-alt-circle-right"></i>
                        </button>
                    </div>
                </div>
                :
                <div></div>

            }

        </>


    );
};
